import { Controller } from "@hotwired/stimulus"

/**
 * Simple dropdown toggle for the profile menu in the top nav.
 * Closes on outside click or Escape.
 */
export default class extends Controller {
  static targets = ["menu"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.menuTarget.classList.add("hidden")
    }
  }

  connect() {
    this._outsideClick = this.close.bind(this)
    this._escape = this.closeOnEscape.bind(this)
    document.addEventListener("click", this._outsideClick)
    document.addEventListener("keydown", this._escape)
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClick)
    document.removeEventListener("keydown", this._escape)
  }
}
